import { FC } from 'react';

import { PhotoProposal } from '../model';

import axios from '../../sharedModules/utils/axios.utils';

import InlineSaveField from './InlineSaveField';

interface PhotoProposalTitleEditFieldProps {
  photoProposal: PhotoProposal;
  fetchPhotoProposal: () => void;
}

const PhotoProposalTitleEditField: FC<PhotoProposalTitleEditFieldProps> = ({ photoProposal, fetchPhotoProposal }) => {
  const handleSave = async (title: string) => {
    await axios.put(`/photo_proposals/photo_proposals/${photoProposal?.id}`, {
      photo_page_proposal: { title },
    });
    fetchPhotoProposal();
  };

  return <InlineSaveField value={photoProposal?.title ?? ''} onSave={handleSave} label="Proposal Title" rows={5} />;
};

export default PhotoProposalTitleEditField;
